export async function useCountries(target: string | HTMLInputElement) {
  const selectContainer = typeof target === 'string' ? document.querySelector<HTMLInputElement>(target) : target

  if (!selectContainer) return

  const { default: intlTelInput } = await import('intl-tel-input')
  // @ts-ignore
  await import('intl-tel-input/build/css/intlTelInput.css')
  intlTelInput(selectContainer, {
    // @ts-ignore
    loadUtils: () => import('intl-tel-input/utils'),
    // separateDialCode: true,
    initialCountry: 'pe',
    // geoIpLookup: (success, failure) => {
    //   fetch("https://ipapi.co/json")
    //     .then((res) => res.json())
    //     .then((data) => success(data.country_code))
    //     .catch(() => failure());
    // }
    i18n: {
      searchPlaceholder: 'Buscar un país',
    }
  })
}